import { domain } from 'modules/data';
import { GetStarterGuideOrganisationSteps } from 'shared/data/myAccount/v2';

export interface GettingStartedProps {
    companyId: string;
    integrationType?: domain.IntegrationType;
    companyDisplayName: string;
    steps: GetStarterGuideOrganisationSteps['response']['steps'];
}

export interface UseGettingStartedStepsParams extends GettingStartedProps {
    useCase: string;
}

export interface StepCommonProps {
    number: number;
    collapsed: boolean;
    complete: boolean;
}

export enum GuideStep {
    IntroductionVideo = 'learn-approvalmax-with-video',
    TeamInvitation = 'invite-teammates',
    WorkflowSetup = 'setup-workflow-gl',
    WorkflowSetupStandalone = 'setup-workflow-standalone',
    RequestCreation = 'create-request',
    RequestApproval = 'get-first-approval',
    ConnectAccountingSystem = 'connect-gl-account',
    MobileAppDownload = 'download-mobile-apps',
    SubscriptionPlan = 'purchase-subscription',
}
